import { useState } from "react";

const EmailToFormatter = ({ emails }) => {
  const [expanded, setExpanded] = useState(false);

  if (!Array.isArray(emails) || emails.length === 0) {
    return null; // Return nothing if no emails are available
  }

  const visibleEmails = expanded
    ? emails.join(", ")
    : emails.slice(0, 2).join(", ");
  const showReadMore = emails.length > 2;

  return (
    <div>
      {visibleEmails}
      {showReadMore && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
        >
          {expanded ? " Read Less" : " Read More"}
        </span>
      )}
    </div>
  );
};

export default EmailToFormatter;
